import React from 'react';


import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import RG from '@mui/material/RadioGroup';
const RadioGroup = ({
	name,
	label,
	value = '',
	onChange,
	options = [],
	row,
	disabled,
}) => {
	const radios = options.map((option, index) => {
		return (
			<FormControlLabel
				value={option.value}
				control={<Radio selected={option.value === value} />}
				label={option.label}
				key={`${option.value}-${index}`} />
		);
	});

	return (
		<FormControl component="fieldset" sx={{ marginBottom: 2 }} disabled={disabled}>
			<FormLabel component="legend">{label} </FormLabel>
			<RG aria-label={label} name={name} value={value} onChange={onChange} row={row}>
				{radios}
			</RG>
		</FormControl>
	);
};


RadioGroup.type = 'RadioGroup';

RadioGroup.spec = [{
	name: 'RadioGroup',
	key: 'RadioGroup',
	title: 'Multiple choice',
	icon: 'Circle',
	category: 'input',
	translatable: ['label', 'options'],
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}, {
		type: 'repeater',
		label: 'Radio Options',
		name: 'options',
		fields: [{
			type: 'TextField',
			name: 'label',
			label: 'option label',
		}, {
			type: 'TextField',
			name: 'value',
			label: 'option value',
		}],
	}],
}];

export default RadioGroup;